export default __webpack_public_path__ + "78c3afd9d7650b08c68a5676742efd97.svg";